export default __webpack_public_path__ + "static/media/MotherDay_10.bee34c73.png";